import React from 'react'
import { useTranslation } from 'react-i18next'
import { Chip } from '@mui/material'

const StatusChip = ({ status }) => {
  const { t } = useTranslation()

  const getLabel = () => {
    switch (status) {
      case 0:
        return t("alert_pending")
      case 1:
        return t("alert_acknowledge")
      case 2:
        return t("alert_resolve")
      case -1:
        return t("alert_invalid")
      default:
        return null
    }
  }

  const getStyle = () => {
    switch (status) {
      case 0:
        return "secondary"
      case 1:
        return "primary"
      case 2:
        return "success"
      case -1:
        return "warning"
      default:
        return null
    }
  }

  return (
    <div>
      <Chip label={getLabel()} color={getStyle()} variant="outlined" />
    </div>
  )
}

export default StatusChip
